module.exports = __webpack_public_path__ + "img/google@2x.7973d661.png";